import { TFunction } from 'i18next'

export const LOCALE_OPTIONS = [
    {
        label: 'vi-VN',
        value: 'vi-VN',
    },
    {
        label: 'en-US',
        value: 'en-US',
    },
]

export const LOCALE_PUBLIC = [
    {
        label: 'Public',
        value: true,
    },
    {
        label: 'UnPublic',
        value: false,
    },
]

export const JOB_STATUS = (t: TFunction) => [
    {
        label: t('job-opened'),
        value: 'Opened',
    },
    {
        label: t('job-closed'),
        value: 'Closed',
    },
]

export const JOB_TYPE = [
    {
        label: 'Permanent',
        value: 'Permanent',
    },
    {
        label: 'Temporary / Project',
        value: 'Temporary / Project',
    },
    {
        label: 'Shift / Partime',
        value: 'Shift / Partime',
    },
    {
        label: 'Freelance',
        value: 'Freelance',
    },
]

export const JOB_LEVEL = [
    {
        label: 'Experienced (Non - Manager)',
        value: 'Experienced (Non - Manager)',
    },
    {
        label: 'Executive Management',
        value: 'Executive Management',
    },
    {
        label: 'Senior Management',
        value: 'Senior Management',
    },
    {
        label: 'Manager',
        value: 'Manager',
    },
    {
        label: 'Team Leader / Supervisor',
        value: 'Team Leader / Supervisor',
    },
    {
        label: 'Entry Level',
        value: 'Entry Level',
    },
    {
        label: 'Student / Internship',
        value: 'Student / Internship',
    },
]

export const JOB_COUNTRY = [
    {
        label: 'Vietnam',
        value: 'Vietnam',
    },
    {
        label: 'Korea',
        value: 'Korea',
    },
    {
        label: 'Singapore',
        value: 'Singapore',
    },
    {
        label: 'HongKong',
        value: 'HongKong',
    },
    {
        label: 'Taiwan',
        value: 'Taiwan',
    },
]

export const generateSlug = (title: string) => {
    return title
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
}
